import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  resetProgram({ commit }, data) {
    commit(types.RESET_BODYCOMPOSITION, data)
  },
  async getBodyComposition({ commit }, data) {
    const r = await http.get(`v2/bodycomp/liveprofilebodycomp`, {
      params: data,
    })
    commit(types.SET_BODYCOMPOSITION, r.data.data)
    return r.data.data
  },
  async getBodyFatChartValues({ commit }, data) {
    const r = await http.get(`v2/bodycomp/liveprofilebodyfatchart`, {
      params: data,
    })
    commit(types.SET_BODYFATCHART, r.data.data)
    return r.data.data
  },
  async getBodyWeightChartValues({ commit }, data) {
    const r = await http.get(`v2/bodycomp/liveprofilebodyweightchart`, {
      params: data,
    })
    commit(types.SET_BODYWEIGHTCHART, r.data.data)
    return r.data.data
  },
  async getBodyChartValues({ commit }, data) {
    const r = await http.get(`v2/bodycomp/liveprofilebodycharts`, {
      params: data,
    })
    commit(types.SET_BODYCHARTS, r.data.data)
    return r.data.data
  },
  async saveTarget({ commit }, data) {
    const r = await http.post(`v2/bodycomp/target`, data)
    commit(types.SET_TARGETS, r.data.data)
    return r.data.data
  },
  async createMeasurement({ commit }, data) {
    const r = await http.post(`v2/bodycomp/createMeasurement`, data)
    return r.data.data
  },
  async getMeasurements({ commit }, data) {
    const r = await http.get('v2/bodycomp/measurements', {
      params: data,
    })
    commit(types.SET_MEASUREMENTS, r.data.data)
    return r.data.data
  },
  async saveInitialMeasurement({ commit }, data) {
    const r = await http.post(`v2/bodycomp/initial`, data)
    commit(types.SET_INITIAL_MEASUREMENT, data)
    return r.data.data
  },
  async createFullMeasurement({ commit }, data) {
    const r = await http.post(`v2/bodycomp/createFullMeasurement`, data)
    return r.data.data
  },
}
